<script>
export default {
  created() {
    window.location.replace('/404.html');
  },
};
</script>
